import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ImageModalComponent } from '../../core/image-modal/image-modal.component';
import { MmtVisitDetail, MmtCovidVisitDetail } from 'src/app/models/mmt.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-mmt-covid-visit',
  templateUrl: './mmt-covid-visit.component.html',
  styleUrls: ['./mmt-covid-visit.component.scss']
})
export class MmtCovidVisitComponent implements OnInit {

  visit: MmtVisitDetail;
  covid: MmtCovidVisitDetail;
  photos: string[];

  get client() {
    return this.auth.client;
  }

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private modalService: BsModalService
    ) { }

  ngOnInit() {
    this.route.data.subscribe((data: Data) => {
      this.visit = data.visit.visit;
      this.covid = data.covid.visit;
      this.photos = data.covid.photos;
    })
  }

  imageUrl(img: string) {
    return '/assets/images/mmt-covid/photos/' + this.visit.id + '/' + img;
  }

  onImageClick(img: string) {
    this.modalService.show(ImageModalComponent, { class: 'modal-lg', initialState: { url: this.imageUrl(img) } });
  }
}
